<script setup>
import { computed } from 'vue'
import { entityAppearanceStyle } from '../../pts2/entityAppearance.js'

const props = defineProps({
  entityId: { type: [Number, String], default: null },
  label: { type: String, default: '—' },
})
const style = computed(() => entityAppearanceStyle(props.entityId, props.label))
</script>

<template>
  <span class="pts2-entity-badge" :style="style">{{ label || '—' }}</span>
</template>
